export const capitalize = (s: string): string => s[0].toUpperCase() + s.slice(1);

export const formatEmptyText = (value: number | null | undefined | string): number | string => {
  return value === 0 || value === null || value === undefined ? "—" : value;
};

export const getFormPageTitle = (title: string, isEdit: boolean): string =>
  `${isEdit ? "Edit" : "Add"} ${title}`;
